module.exports = __webpack_public_path__ + "static/media/auth0-create-tenant-step4.9d8f0af5.png";